export default __webpack_public_path__ + "static/media/animated-system.f1d45e06.png";